import React, { Component } from 'react';
import { Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import DateTime from 'react-datetime';
import { connect } from 'react-redux';
import 'style/react-datetime.css';

import Loader from '../../Loader';

class Create extends Component {
	render() {
		let { AppConfig, actions } = this.props;

		let {
			isLoadingAction,

			evoucherNotif_dailyAM,
			evoucherNotif_dailyPM,
		} = AppConfig;

		let requiredSpan = <span style={{ color: 'red' }}>*</span>;

		return (
			<form>
				<Loader loading={isLoadingAction} />
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>Daily AM {requiredSpan}</ControlLabel>
							<DateTime
								dateFormat={false}
								timeFormat="HH:mm"
								value={evoucherNotif_dailyAM}
								onChange={(date) => actions.setValue({ evoucherNotif_dailyAM: date })}
								inputProps={{
									placeholder: 'Daily AM',
								}}
							/>
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>Daily PM {requiredSpan}</ControlLabel>
							<DateTime
								dateFormat={false}
								timeFormat="HH:mm"
								value={evoucherNotif_dailyPM}
								onChange={(date) => actions.setValue({ evoucherNotif_dailyPM: date })}
								inputProps={{
									placeholder: 'Daily PM',
								}}
							/>
						</FormGroup>
					</Col>
				</Row>
			</form>
		);
	}
}

function mapStateToProps(state) {
	let { AppConfig } = state;

	return {
		AppConfig,
	};
}

export default connect(mapStateToProps)(Create);



// WEBPACK FOOTER //
// ./components/AppConfig/FormContainer/EVoucherNotifForm.js